module.exports = __webpack_public_path__ + "img/707-9dfe14.png";